import ContactSection from "../components/Contact";
import Navbar from "../components/Navbar";
import CaseTemplate from "../components/templates/CaseTemplate";

function ProjectPage() {
  return (
    <>
      <Navbar />
      <CaseTemplate />
      <ContactSection />
    </>
  );
}

export default ProjectPage;
